import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

interface TagInputProps {
  tags: string[];
  onChange: (tags: string[]) => void;
  error?: boolean;
}

export default function TagInput({ tags, onChange, error }: TagInputProps) {
  const { theme } = useTheme();
  const [currentTag, setCurrentTag] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && currentTag.trim() && !tags.includes(currentTag.trim())) {
      e.preventDefault();
      onChange([...tags, currentTag.trim()]);
      setCurrentTag('');
    }
  };

  const removeTag = (tagToRemove: string) => {
    onChange(tags.filter(tag => tag !== tagToRemove));
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {tags.map(tag => (
          <span
            key={tag}
            className={`
              flex items-center space-x-1 px-3 py-1 rounded-full text-sm
              ${theme === 'dark'
                ? 'bg-gray-700 text-gray-200'
                : 'bg-gray-100 text-gray-700'
              }
            `}
          >
            <span>#{tag}</span>
            <button
              type="button"
              onClick={() => removeTag(tag)}
              className="hover:text-red-500"
            >
              <X className="h-4 w-4" />
            </button>
          </span>
        ))}
      </div>
      <input
        type="text"
        value={currentTag}
        onChange={(e) => setCurrentTag(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Add tags (press Enter)"
        className={`
          w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
          ${theme === 'dark'
            ? 'bg-gray-700 border-gray-600 text-gray-100'
            : 'bg-white border-gray-300 text-gray-900'
          }
          ${error ? 'border-red-500' : ''}
        `}
      />
    </div>
  );
}